import React from 'react';
import { useParams } from 'react-router-dom';

import Permissions from '@/common/permissions';
import { Access } from '@/modules/core/components';
import FieldLevelAccessSetup from '@/modules/role/FieldLevelAccessSetup';
import useFieldLevelAccessLoad from '@/modules/role/FieldLevelAccessSetup/hooks/useFieldLevelAccessLoad';

const FieldLevelAccessEditPage = () => {
  const { id } = useParams<{ id: string }>();

  const { isLoading } = useFieldLevelAccessLoad(id);
  return (
    <Access
      accessRequirements={[
        { permission: Permissions.EDIT_ROLES_AND_SECURITY },
      ]}>
      <FieldLevelAccessSetup isEditMode isLoading={isLoading} id={id} />
    </Access>
    
  );
};
export default FieldLevelAccessEditPage;
